module.exports = __webpack_public_path__ + "static/media/blue-paper_max.51fc4d5f.png";